import { IChangePassword, IForgotPassword } from './auth.interface';
import { createAction, props } from '@ngrx/store';


export const loginUser = createAction(
  '[Auth Module] login user',
  props<{ credentials: { identifier: string, password: string } }>()
);

export const loginUserSuccessful = createAction(
  '[Auth Module] login user successful'
);

export const loginUserFailed = createAction(
  '[Auth Module] login user failed',
  props<{message: string, code: number}>()
);

export const forgotPassword = createAction(
  '[Auth Module] forgot password',
  props<{ email:string,source: string}>()
);
 
export const forgotPasswordSuccessful = createAction(
  '[Auth Module] forgot password successful'
);

export const forgotPasswordFailed = createAction(
  '[Auth Module] forgot password failed',
  props<{message: string, code: number}>()
);
export const changePassword = createAction(
  '[Auth Module] changed password',
  props<{email:string, payload:IChangePassword}>()
);

export const changePasswordSuccessful = createAction(
  '[Auth Module] changed password successful'
);

export const changePasswordFailed = createAction(
  '[Auth Module] changed password failed',
  props<{message: string, code: number}>()
);

export const logout = createAction(
  '[Auth Module] logout'
);


